import { render, staticRenderFns } from "./browser.vue?vue&type=template&id=52aae03e&scoped=true&lang=pug&"
import script from "./browser.vue?vue&type=script&lang=js&"
export * from "./browser.vue?vue&type=script&lang=js&"
import style0 from "./browser.vue?vue&type=style&index=0&id=52aae03e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52aae03e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('52aae03e', component.options)
    } else {
      api.reload('52aae03e', component.options)
    }
    module.hot.accept("./browser.vue?vue&type=template&id=52aae03e&scoped=true&lang=pug&", function () {
      api.rerender('52aae03e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/design_token/browser.vue"
export default component.exports